import { useEffect, useState } from 'react';
import { TIMEOUT_MINIMAL } from '../constants/system/timeouts';

const useFormStructureModified: Function = (
  modifiedFieldMap: Record<string, boolean>, isDataLoaded: boolean,
): boolean => {
  const [isFormStructureModified, setIsFormStructureModified]: [boolean, Function] = useState(false);
  const [initialFormFieldHash, setInitialFormFieldHash]: [string | null, Function] = useState(null);

  const formFieldList: string[] | null = (modifiedFieldMap && Object.keys(modifiedFieldMap)) || null;
  const formFieldHash: string | null = formFieldList && formFieldList.length
    ? formFieldList.join('') : null;

  useEffect((): void => {
    if (isDataLoaded && formFieldHash && (!initialFormFieldHash
      || (!isFormStructureModified && initialFormFieldHash !== formFieldHash)
      || (isFormStructureModified && initialFormFieldHash === formFieldHash))) {
      setTimeout((): void => {
        if (!initialFormFieldHash) {
          setInitialFormFieldHash(formFieldHash);
        }

        if (initialFormFieldHash) {
          setIsFormStructureModified(formFieldHash !== initialFormFieldHash);
        }
      }, TIMEOUT_MINIMAL);
    }
  }, [formFieldHash]);

  return isFormStructureModified;
};

export default useFormStructureModified;
